import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './root-reducer';

import performanceMiddleware from './performance-middleware';
import biMiddleware from 'shared/bi/bi-middleware';
import biHandlers from 'widget/redux/bi-middleware/bi-handlers';


export default function configureStore(initialState = {}) {
  // Compose final middleware and use devtools extension in debug environment
  const middlewares = [
    thunk,
    biMiddleware(biHandlers),
    performanceMiddleware,
  ];

  if (__DEBUG__) {
    const reduxLogger = require('redux-logger').createLogger({
      collapsed: true,
      diff: true,
    });
    middlewares.push(reduxLogger);
  }

  let middleware = applyMiddleware(...middlewares);

  if (__DEBUG__) {
    if (window.devToolsExtension) {
      const devTools = window.devToolsExtension();
      middleware = compose(middleware, devTools);
    }
  }

  // Create final store and subscribe router in debug env ie. for devtools
  const store = middleware(createStore)(rootReducer, initialState);

  if (module.hot) {
    module.hot.accept('./root-reducer', () => {
      const nextRootReducer = require('./root-reducer').default;
      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
}



// WEBPACK FOOTER //
// ./src/widget/redux/configure-store.js